import React, {Component} from 'react';
import './index.scss';
import $ from 'jquery'
import API from '../../../config/api';
import {Toast} from "antd-mobile";
import MoreComment from "../MoreComment";

export default class Comment extends Component {
  constructor(props){
    super(props);
    this.state = {
      isMore : false,
      moreComment : [],
      mainComment : {}
    }
  }

  componentDidMount() {

  }

  //返回回复评论值
  getBackComment = (data)=>{
    if(data.root_uuid/1 !== data.parent_uuid/1 ){  //显示@
      return `${data.user_name}回复@${data.at_user_name}：${data.content}`
    }else {   //不显示@
      return `${data.user_name}：${data.content}`
    }
  }

  //获取全部回复列表
  getAllBack = (data)=>{
    $.ajax({
      url : API.reply_list,
      dataType : 'json',
      type : 'GET',
      data : {
        comm_uuid : data.comm_uuid
      }
    }).done((res)=>{
      if(res.code === 0){
        this.setState({
          moreComment :res.data,
          isMore : true,
          mainComment :data
        })
      }else {
        Toast.fail(res.msg || res.error);
      }
    }).fail(()=>{
      Toast.fail('内部服务器错误！');
    })
  }

  //关闭所有评论弹框
  closeMore = ()=>{
    this.setState({
      isMore :false
    })
  }

  render() {
    const {commentData} = this.props
    const {isMore} = this.state
    return <div className="comment_box">
      {isMore ?
        <MoreComment moreComment={this.state.moreComment}
                     mainComment={this.state.mainComment}
                     closeMore={this.closeMore}
        /> : ''
      }
      { commentData.length > 0 ?
        commentData.map((item,index)=>{
          if(item.is_top/1 === 1) {  //置顶留言
            return <div className="topComment_box comment_mainBox"
                        key={index}>
              <div className="topIconBox">
                {/*<div className="topIcon"></div>*/}
                {/*<div className="topText">置顶</div>*/}
              </div>
              <div className="userHead">
                <img src={item.head_image} alt="头像"/>
                {item.data_from/1 === 3 ?
                  <div className="weibo_icon"></div> : ''
                }
              </div>
              <p className="userName">{item.user_name}</p>
              <p className="commentTime">{item.add_time}</p>
              <p className="commentContent">{item.content}</p>
              {item.reply_list.length > 0 ?
                <div className="reply_box">
                  {item.reply_list.map((replyItem,replyIndex)=>{
                    return <div className="replyBox"
                                key={replyIndex}>
                      <div className="reply_head">
                        <img src={replyItem.head_image} alt="头像"/>
                        {replyItem.data_from/1 === 3 ?
                          <div className="weibo_icon"></div> : ''
                        }
                      </div>
                      <div className="reply_content">
                        {this.getBackComment(replyItem)}
                      </div>
                      <div className="clear"></div>
                    </div>
                  })}
                  {item.re_num/1  > 3 ?   //回复数量
                    <p className="seeAllBtn"
                       onClick={this.getAllBack.bind(this,item)}>
                      共{item.re_num}条回复 ></p> : ''
                  }
                </div> : ''
              }
            </div>
          }else {
            return <div className="normalComment_box comment_mainBox"
                        key={index}>
              <div className="userHead">
                <img src={item.head_image} alt="头像"/>
                {item.data_from/1 === 3 ?
                  <div className="weibo_icon"></div> : ''
                }
              </div>
              <p className="userName">{item.user_name}</p>
              <p className="commentTime">{item.add_time}</p>
              <p className="commentContent">{item.content}</p>
              {item.reply_list.length > 0 ?
                <div className="reply_box">
                  {item.reply_list.map((replyItem,replyIndex)=>{
                    return <div className="replyBox"
                                key={replyIndex}>
                      <div className="reply_head">
                        <img src={replyItem.head_image} alt="头像"/>
                        {replyItem.data_from/1 === 3 ?
                          <div className="weibo_icon"></div> : ''
                        }
                      </div>
                      <div className="reply_content">
                        {this.getBackComment(replyItem)}
                      </div>
                      <div className="clear"></div>
                    </div>
                  })}
                  {item.re_num/1  > 3 ?   //回复数量
                    <p className="seeAllBtn"
                       onClick={this.getAllBack.bind(this,item)}>
                      共{item.re_num}条回复 ></p> : ''
                  }
                </div> : ''
              }
              {index < commentData.length -1 ?
                <div className="commentBottomLine"></div> : ''
              }
            </div>
          }
        }) : ''
      }
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/pages/Detail/Comment/index.js